module.exports = __webpack_public_path__ + "img/logo-inst-jugendapp-300x300.9e21b6bf.png";